import React from 'react';
import { ReactComponent as FigBuilding08Component } from './FigBuilding08.svg';

const FigBuilding08 = (props) => <FigBuilding08Component {...props} />;

export default FigBuilding08;
